namespace GeniuzPOS.ReportMasterData {
    export class Report_1413Columns {
        static columnsKey = 'ReportMasterData.Report_1413';
    }
}
